<template>
    <v-footer
            height="auto"
            color="primary"
    >
        <v-layout
                justify-center
                row
                wrap
        >
<!--            <v-btn-->
<!--                    v-for="link in links"-->
<!--                    :key="link"-->
<!--                    color="white"-->
<!--                    flat-->
<!--                    round-->
<!--            >-->
<!--                {{ link }}-->
<!--            </v-btn>-->
            <v-flex
                    primary
                    py-3
                    text-xs-center
                    white--text
                    xs12
            >
                 {{ new Date().getFullYear() }} — <strong>Powered by Intrare</strong>
                  <v-spacer/>
                  <a style="color: #dddddd" href="https://empresas.intrare.app/notice_privacy" target="_blank">Aviso de privacidad</a>
            </v-flex>
        </v-layout>
    </v-footer>
</template>

<script>
    export default {
        name: "Foot",
        data: () => ({
          links: [
            'Home',
            'About Us',
            'Team',
            'Services',
            'Blog',
            'Contact Us'
          ]
        })
    }
</script>

<style scoped>

</style>
